import CloseIcon from '@mui/icons-material/Close';
import { Box, styled } from '@mui/material';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  color: theme.palette.common.white,
  background: theme.palette.primary.main,
  borderRadius: '.5rem',
  gap: '2rem',
  padding: '1.5rem',
  maxWidth: '19.5rem',

  [theme.breakpoints.up('sm')]: {
    maxWidth: '100%',
  },
}));

export const TitleContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  justifyContent: 'space-between',
  gap: '1.2rem',
  padding: '.9rem',
  backgroundColor: `${theme.palette.primary.main}`,
  marginBottom: '1rem',
}));

export const Header = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const changeValuePaperPropsStyle = {
  style: {
    backgroundColor: 'transparent',
    maxWidth: '25rem',
  },
};

export const StyledCloseIcon = styled(CloseIcon)(() => ({
  marginBottom: '1rem',
  alignSelf: 'flex-end',
  cursor: 'pointer',
}));

export const AlignButtons = styled('div')(({ theme }) => ({
  display: 'flex',
  padding: '1rem 0',
  justifyContent: 'center',
  width: '100%',
}));

export const CountContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignContent: 'center',
  alignItems: 'center',
  gap: '1.5rem',
}));

export const InvalidRowsContainer = styled(Box)(({ theme }) => ({
  border: '1px solid',
  borderColor: theme.palette.secondary.main,
  borderRadius: '0.5rem',
  height: '7.5rem',
  overflow: 'auto',
  padding: '1rem',
}));

export const InvalidRowStyled = styled(Box)(({ theme }) => ({
  paddingBottom: '1.5rem',
}));
